// import Vue from 'vue'
import {VNodeData} from 'vue/types/vnode'

export default class Colorable {
  public static setTextColor(color?: string | false, data: VNodeData = {}): VNodeData {
    if (Colorable.isCssColor(color) && typeof data.style === 'object') {
      data.style = {
        ...data.style,
        'color': `${color}`,
        'caret-color': `${color}`,
      }
    } else if (color) {
      const [colorName, colorModifier] = color.toString().trim().split(' ', 2) as Array<string | undefined>
      data.class = {
        ...data.class,
        [colorName + '--text']: true,
      }
      if (colorModifier) {
        data.class['text--' + colorModifier] = true
      }
    }
    return data
  }

  public static setBackgroundColor(color?: string | false, data: VNodeData = {}): VNodeData {
    if (Colorable.isCssColor(color) && typeof data.style === 'object') {
      data.style = {
        ...data.style,
        'background-color': `${color}`,
        'border-color': `${color}`,
      }
    } else if (color) {
      data.class = {
        ...data.class,
        [color]: true,
      }
    }
    return data
  }

  private static isCssColor(color?: string | false): boolean {
    return !!color && !!color.match(/^(#|(rgb|hsl)a?\()/)
  }

  public static parseColor(color: string | number) {
    const memoize = function (factory: (col: any) => number[], ctx?: CanvasRenderingContext2D) {
      const cache: {[index: string]: number[]} = {}
      return function (key: string | number) {
        if (!(key in cache)) {
          cache[key] = factory.call(ctx, key)
        }
        return cache[key]
      }
    }

    const colorToRGBA = (function () {
      const canvas = document.createElement('canvas')
      canvas.width = canvas.height = 1
      const ctx = canvas.getContext('2d')!
      // invalid values of "col" are ignored
      return memoize(function (col) {
        ctx.clearRect(0, 0, 1, 1)
        ctx.fillStyle = col
        ctx.fillRect(0, 0, 1, 1)
        return [...ctx!.getImageData(0, 0, 1, 1).data]
      })
    })()

    return {
      r: colorToRGBA(color)[0],
      g: colorToRGBA(color)[1],
      b: colorToRGBA(color)[2],
      a: colorToRGBA(color)[3],
    }
  }

  public static averageColors = (color1: string | number, color2: string | number) => {
    const c1 = Colorable.parseColor(color1)
    const c2 = Colorable.parseColor(color2)
    return {
      r: (c1.r + c2.r)/ 2,
      g: (c1.g + c2.g)/ 2,
      b: (c1.b + c2.b)/ 2,
      a: (c1.a + c2.a)/ 2,
    }
  }

  public static lightContrast = (color1: string | number, color2?: string | number) => {
    const rgb = color2 ? Colorable.averageColors(color1, color2) : Colorable.parseColor(color1)!
    const luminance = (0.2126 * rgb['r'] + 0.7152 * rgb['g'] + 0.0722 * rgb['b'])
    return (luminance > 167)
  }
}

//
// function isCssColor(color?: string | false): boolean {
//   return !!color && !!color.match(/^(#|(rgb|hsl)a?\()/)
// }
//
// export default Vue.extend({
//   name: 'colorable',
//
//   props: {
//     color: String,
//   },
//
//   methods: {
//     setBackgroundColor(color?: string | false, data: VNodeData = {}): VNodeData {
//       if (isCssColor(color)) {
//         data.style = {
//           ...data.style,
//           'background-color': `${color}`,
//           'border-color': `${color}`,
//         }
//       } else if (color) {
//         data.class = {
//           ...data.class,
//           [color]: true,
//         }
//       }
//
//       return data
//     },
//
//     setTextColor(color?: string | false, data: VNodeData = {}): VNodeData {
//       if (isCssColor(color)) {
//         data.style = {
//           ...data.style,
//           'color': `${color}`,
//           'caret-color': `${color}`,
//         }
//       } else if (color) {
//         const [colorName, colorModifier] = color.toString().trim().split(' ', 2) as Array<string | undefined>
//         data.class = {
//           ...data.class,
//           [colorName + '--text']: true,
//         }
//         if (colorModifier) {
//           data.class['text--' + colorModifier] = true
//         }
//       }
//       return data
//     },
//   },
// })
